import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { getAdvanceDebitorBalanceApi } from "../../apiservice/reports";

export const fetchAdvanceCustomerBalance = createAsyncThunk(
  "advanceCustomerBalance/fetch",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getAdvanceDebitorBalanceApi(payload);

      const mapped = res.data.accounts.map((row, idx) => ({
        id: idx + 1,
        customerName: row.acc_name,
        contactNo: row.contact_no,
        address: row.address,
        received: row.rcv_amount,
        payment: row.pay_amount,
        balance: row.balance,
      }));

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
